import { getAgentsKey, useCreateAgent } from 'api-hooks/agent';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import AgentForm from './components/form';

export type AgentCreateParams = null;

export default function AgentCreate(
  props: NavigationProps<NavigationRoutes.AgentsCreate>,
) {
  const { navigate, back } = useNavigation();

  const { mutateAsync, error } = useCreateAgent();
  const permission = useGetCrudPermission('agents');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <AgentForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getAgentsKey()[0]]);

          const prevPath = PreviousNavigation.get();
          if (prevPath) {
            PreviousNavigation.remove();
            back();
          } else if (permission.view) {
            navigate(NavigationRoutes.AgentsView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
